import React, { useContext } from 'react';
import IconButton from 'components/IconButton';
import { OverlayContext } from './constants';

function CloseButton({ sx }) {
  const { onClose, fullScreen } = useContext(OverlayContext);

  return (
    <IconButton
      aria-label="close"
      onClick={onClose}
      variant="link"
      name={fullScreen ? 'arrow-withtale-left' : 'close-outlined'}
      sx={sx}
    />
  );
}
export default CloseButton;
